import Device from '@/helpers/Device';
import PowerStateWrapper from "@/helpers/Device/PowerStateWrapper";
import StorageHandler, {
  STORE_KEY,
  STORE_VALUE,
} from '@/helpers/StorageHandler';
import store from '@/store';
import ForeignApp from '@/helpers/ForeignApp';
import BringToFront from '@/helpers/BringToFront';

console.log("TIZEN keyHandler b2bapis (window):", window.hasB2bapis);
console.log("TIZEN keyHandler webapis (window):", window.hasWebapis);

export default class KeyHandlingTizen {
  static get getKeys() {
    return [
      'Menu',             //18
      'ChannelUp',        //427
      'ChannelDown',      //428
      'Exit',             //10182
      'XF86Exit',         //10182
      'XF86SysMenu',      //10133
      'ChannelList',      //10073 (Info)
      'XF86Ambient',      //10232
      'PreviousChannel',  //10190
      'Guide',            //458
      'MediaPlay',        //415
      'MediaPlayPause',   //10252 (XF86Home / SmartHub)
      'MediaPause',       //19
      'MediaStop',        //413
      'MediaFastForward', //417
      'MediaRewind',      //412
      'Info',             //457
      '0',                //48
      '1',                //49
      '2',                //50
      '3',                //51
      '4',                //52
      '5',                //53
      '6',                //54
      '7',                //55
      '8',                //56
      '9',                //57
      'Minus',            //189
      'ColorF0Red',       //403
      'ColorF1Green',     //404
      'ColorF2Yellow',    //405
      'ColorF3Blue',      //406
      'Tools',            //10135 (Menu)
      'Source',           //10072
      'Search',           //10225
      'Back',             //10009
      'Enter',            //13
      'Home',             //10071
      'Voice ',           //10253 (Settings)
      'Netflix',          //10074
      'PrimeVideo',       //10256
      'DisneyPlus',       //10257
      'SamsungTVPlus',    //10258
      'GamingHub',        //10259
      'ArtMode',          //10260
      'Apps',             //10077
      'HotelInfo',        //10300
      'HotelMenu',        //10301
      'Interactive',      //10302
      'MyRoom',           //10303
      'TVPlus',           //10303
      'MultiView',        //10303
      'WebBrowser',       //10303
      'Ambient',          //10303
      //'Power',          //409
    ];
  }

  static powerWrapper = null;

  // Den Merker "der letzte Wechsel in den Hintergrund war ein echter Standby"
  // haelt jetzt der cast-Store (clearPending). Er muss einen Kaltstart
  // ueberleben - mit Virtual Standby Off bootet der TV beim Einschalten neu, und
  // ein statisches Feld waere dann weg.

  static get getSpecialKeys() {
    const keys = ['SmartHub', 'TVPlus', 'MultiView', 'WebBrowser', 'Power', 'Sleep', 'XF86Ambient', 'Ambient', 'Apps', 'SamsungTVPlus'];
    return KeyHandlingTizen.appHandlesPower() ? keys : keys.filter((k) => k !== 'Power');
  }

  // Darf die App die POWER-Taste selbst behandeln?
  //
  // Nur, wenn sie den TV mit derselben API aus- UND wieder einschalten kann.
  // Am AU800 (Tizen 6.0) hat b2bpower kein setPowerOff: device/turnOff geht
  // dort ueber b2bcontrol.setPowerOff, der Bildschirm geht aus, die App laeuft
  // weiter - und b2bpower.setPowerOn ruft danach keinen Callback und schaltet
  // nichts ein. Der Bildschirm blieb schwarz; jeder weitere Druck schaltete
  // laut gespeichertem Zustand wieder "aus".
  //
  // Ohne Registrierung behandelt die Firmware die Taste selbst (echter
  // Standby und Aufwachen). Das Cast-Aufraeumen haengt am Power-Listener,
  // nicht an der Taste (siehe prepareCastStandby).
  static appHandlesPower() {
    const b2b = window.b2bapis;
    if (!b2b || !b2b.b2bpower) return true;
    return typeof b2b.b2bpower.setPowerOff === 'function';
  }

  // Sind die Tasten fuer DIESEN App-Start schon registriert?
  //
  // tizen.tvinputdevice.registerKey und webapis.appcommon.registerKey gelten
  // fuer die ANWENDUNG, nicht fuer eine Vue-Komponente. Einmal pro App-Start
  // genuegt also - und mehr ist teuer: rund fuenfzig synchrone Firmware-Aufrufe
  // je Registrierung, und dieselbe Zahl beim Abmelden.
  static _keysRegistered = false;

  // Und dasselbe fuer den Power-Listener: einmal registriert, bleibt er gueltig.
  static _powerListenerSet = false;

  static registerKeys() {
    if (KeyHandlingTizen._keysRegistered) return;
    KeyHandlingTizen._keysRegistered = true;
    for (let i = 0; i < this.getSpecialKeys.length; i++) {
      try {
        webapis.appcommon.registerKey([this.getSpecialKeys[i]]);
        /*
        store.dispatch('notification/new', {
          title: 'Assign Key',
          message: this.getSpecialKeys[i],
        });
        */
      } catch (error) {
        console.log('failed to register - specialkeys: ' + this.getSpecialKeys[i] + ': ' + error);
      }
    }
    // try {
    //   const value = webapis.appcommon.registerKey([this.getSpecialKeys]);
    //   console.log(' result = ' + value);
    // } catch (error) {
    //   console.log(' error code = ' + error.code);
    // }
    // var keyCodes = {};
    // var supportedKeys = tizen.inputdevice.getSupportedKeys();

    // console.log('Supported keys list');
    // for (var i = 0; i < supportedKeys.length; ++i) {
    //   keyCodes[supportedKeys[i].name] = supportedKeys[i].code;
    //   console.log(
    //     i + ' : ' + supportedKeys[i].name + ' - ' + supportedKeys[i].code
    //   );
    // }
    for (let i = 0; i < this.getKeys.length; i++) {
      try {
        tizen.tvinputdevice.registerKey(this.getKeys[i]);
      } catch (error) {
        console.log('failed to register: ' + this.getKeys[i] + ': ' + error);
      }
    }
    const keys = ['VolumeDown', 'VolumeUp', 'VolumeMute'];
    for (let i = 0; i < keys.length; i++) {
      try {
        tizen.tvinputdevice.unregisterKey(keys[i]);
      } catch (error) {
        console.log('failed to UNRegister ' + this.getKeys[i] + ': ' + error);
      }
    }
    /*
    // Kritische Tasten die BLOCKIERT werden müssen
    const BLOCKED_KEYS = [
        10252,  // Home/Smart Hub - KRITISCH!
        10232,  // Ambient Mode - IHR HAUPTPROBLEM!
        10009,  // Back/Return
        10182,  // Exit
        10072,  // Source
        10135,  // Menu/Tools
        10253,  // Settings/Voice
        10077,  // Apps
        427,    // Channel Up
        428,    // Channel Down
        10074,  // Netflix
        10256,  // Prime Video
        10257,  // Disney+
        10259,  // Gaming Hub
    ];

    // Event Handler
    document.addEventListener('keydown', function(event) {
        const keyCode = event.keyCode || event.which;

        if (BLOCKED_KEYS.includes(keyCode)) {
            console.log('🚫 Blockiere Taste:', keyCode);
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
            return false;
        }
    }, true); // true = capture phase!
    */
  }
  static unregisterKeys() {
    for (let i = 0; i < this.getKeys.length; i++) {
      try {
        tizen.tvinputdevice.unregisterKey(this.getKeys[i]);
      } catch (error) {
        console.log('failed to register ' + this.getKeys[i] + ': ' + error);
      }
    }
  }


// Aufraeumen der OTT-/Cast-Daten an den Power-Zustand haengen. No-op, solange
// der Gast nicht gecastet hat.
//
// Warum hier und nicht nur in device/turnOff: die POWER-Taste der Fernbedienung
// erreicht die App auf den meisten Geraeten NICHT - der echte Standby kommt
// ueber den PowerStateChangeListener bzw. den PowerStateWrapper. Ohne diesen
// Haken wuerde beim Druck auf die Power-Taste nichts geloescht.
//
// ZWEI Pfade, und die Trennung ist der Grund, warum der TV jetzt sofort ausgeht:
//   beim Ausschalten nur vormerken (billig, Millisekunden),
//   beim Aufwachen wirklich loeschen (dort ist Zeit).
// Siehe cast/prepareForStandby und cast/clearGuestCredentials.
static prepareCastStandby(reason) {
  try {
    console.log('::===> CAST standby vorbereiten (' + reason + ')');
    // Bestaetigter Standby - kein Fall fuer die Fremd-App-Meldung.
    ForeignApp.noteStandby();
    store.dispatch('cast/prepareForStandby').catch(() => {});
  } catch (e) {
    console.log('[ERROR]: prepareCastStandby', e);
  }
}

static clearCastCredentials(reason) {
  try {
    console.log('::===> CAST clear credentials (' + reason + ')');
    store.dispatch('cast/clearGuestCredentials').catch(() => {});
  } catch (e) {
    console.log('[ERROR]: clearCastCredentials', e);
  }
}

// POWER_STATE speichern und DANACH den Zustand an den Socket melden.
//
// Die Zustandsmeldung hing bisher an visibilitychange und an device/turnOff/
// turnOn. Seit die Firmware die POWER-Taste selbst behandelt (AU800), faellt
// letzteres weg - und visibilitychange kommt VOR der Meldung des Power-
// Listeners, also mit dem alten Zustand. Im SocketAdmin stand dann genau
// verkehrt "Standby" bei hellem Bildschirm. Gemeldet wird erst nach dem
// Speichern, weil readScreen den Merker liest.
static savePowerState(value) {
  Promise.resolve(StorageHandler.save(STORE_KEY.POWER_STATE, value))
    .catch(() => {})
    .then(() => store.dispatch('socket/reportState'));
}

// Ist der TV WIRKLICH im Standby - oder nur eine andere App im Vordergrund?
// visibilitychange allein kann das nicht unterscheiden. remotepower.getPowerState()
// antwortet synchron, laeuft also auch noch, waehrend die App suspendiert wird.
// Im Zweifel false: lieber nicht loeschen als mitten in der Sitzung.
static isRealStandby() {
  try {
    const rp = window.webapis && window.webapis.remotepower;
    if (rp && typeof rp.getPowerState === 'function') {
      const state = String(rp.getPowerState() || '').toUpperCase();
      console.log('::===> POWER_STATE query:', state);
      return state !== '' && state !== 'NORMAL';
    }
  } catch (e) {
    console.log('[ERROR]: isRealStandby', e);
  }
  return false;
}

// Dokumentierter TEP-Power-Listener (webapis.remotepower). Liefert bei jedem
// Wechsel den neuen Zustand; genau daran haengt das Loeschen der
// Gast-Anmeldedaten. Rueckgabe: true, wenn registriert.
static setRemotePowerListener() {
  const rp = window.webapis && window.webapis.remotepower;
  if (!rp || typeof rp.setPowerStateListener !== 'function') return false;
  try {
    rp.setPowerStateListener((data) => {
      const state = String(data).toUpperCase();
      console.log('::===> POWER_STATE (remotepower)', data);
      // Laeuft gerade der Cast-Standby-Neustart (tv-app vorher nach vorn
      // geholt), ist ein NORMAL hier kein Aufwachen des Gastes - hat der launch
      // den TV eingeschaltet, soll der Log das zeigen, aber nichts aufraeumen
      // und kein POWER_STATE=ON schreiben.
      if (BringToFront.isRebootImminent() && state.indexOf('STANDBY') === -1) {
        console.log('[reboot] ' + data + ' waehrend der Neustart-Vorbereitung - hat der launch den TV geweckt?');
        return;
      }
      if (state.indexOf('STANDBY') !== -1 || state.indexOf('OFF') !== -1) {
        BringToFront.cancel();
        KeyHandlingTizen.savePowerState(STORE_VALUE.POWER_OFF);
        KeyHandlingTizen.prepareCastStandby('remotepower ' + data);
      } else {
        KeyHandlingTizen.savePowerState(STORE_VALUE.POWER_ON);
        // Der eigentliche Lauf: was beim Ausschalten nur vorgemerkt wurde, wird
        // jetzt abgearbeitet.
        KeyHandlingTizen.clearCastCredentials('remotepower ' + data);
        // Stellt die Firmware beim Einschalten eine fremde App wieder her
        // (YouTube des vorigen Casts, TV Plus), die Hotel-App nach vorn holen.
        BringToFront.onPowerOn('remotepower ' + data);
      }
    });
    console.log('::===> remotepower.setPowerStateListener registriert');
    return true;
  } catch (e) {
    console.log('[ERROR]: remotepower.setPowerStateListener', e);
    return false;
  }
}

static setPowerStateListener() {
  // Einmal pro App-Start. Der Listener haengt an der Anwendung, nicht an einer
  // Seite - und jede Seite brachte bisher ein neues setPowerStateListener mit.
  if (KeyHandlingTizen._powerListenerSet) return;
  KeyHandlingTizen._powerListenerSet = true;
  console.log('SET POWER STATE LISTENER');
  try {
    if (window.b2bapis) {
      const onChange = (context) => {
        const state = context.data;
        console.log('::===> POWER_STATE (b2bapis)', state);
        if (state === 'Normal' && BringToFront.isRebootImminent()) {
          console.log('[reboot] b2bapis Normal waehrend der Neustart-Vorbereitung - ignoriert');
        } else if (state === 'Normal') {
          KeyHandlingTizen.savePowerState(STORE_VALUE.POWER_ON);
          // Der eigentliche Lauf - beim Ausschalten wurde nur vorgemerkt.
          KeyHandlingTizen.clearCastCredentials('b2bapis Normal');
          BringToFront.onPowerOn('b2bapis Normal');
        } else if (state === 'Standby') {
          BringToFront.cancel();
          // FIX: POWER_OFF speichern, sonst wacht TV sofort wieder auf
          KeyHandlingTizen.savePowerState(STORE_VALUE.POWER_OFF);
          KeyHandlingTizen.prepareCastStandby('b2bapis Standby');
        }
      };
      Device.apis.b2bpower.setPowerStateChangeListener(onChange);
      // Initialen Zustand synchronisieren
      const currentPowerState = Device.apis.b2bpower.getPowerState();
      console.log('::===> INITIAL POWER_STATE sync (b2bapis):', currentPowerState);
      StorageHandler.save(
        STORE_KEY.POWER_STATE,
        currentPowerState === 'Normal' ? STORE_VALUE.POWER_ON : STORE_VALUE.POWER_OFF
      );

    } else if (window.webapis) {
      // Erst der DOKUMENTIERTE TEP-Listener. Er heisst
      // webapis.remotepower.setPowerStateListener - nicht
      // webapis.systemcontrol.setPowerStateChangeListener, unter dem wir ihn
      // frueher gesucht und fuer nicht verfuegbar gehalten haben (Quelle:
      // Samsung Tizen Partner Summit 2026, "TEP Web API's - Power").
      //
      // Das ist die verlaessliche Standby-Meldung: der PowerStateWrapper
      // darunter kennt nur visibilitychange und kann Standby nicht von einem
      // App-Wechsel unterscheiden - genau die Unschaerfe, die das Loeschen der
      // Gast-Anmeldedaten unsicher macht.
      // ZUSAETZLICH, nicht anstelle des PowerStateWrappers.
      //
      // Beim ersten Versuch ersetzte der Listener den Wrapper (fruehes return).
      // Das war falsch: nur der Wrapper haelt POWER_STATE symmetrisch auf OFF,
      // wenn der TV in den Hintergrund geht. Feuert der Listener auf einer
      // Firmware nicht, bleibt im keymanager 'ON' stehen - und dann schaltet
      // die WGT-Startdatei den TV beim naechsten Laden aus dem Standby wieder
      // ein. Genau davor warnt der Kommentar bei onSuspend/onHidden unten.
      KeyHandlingTizen.setRemotePowerListener();
      if (!this.powerWrapper) {
        // Zurueck aus einem ECHTEN Standby (nicht aus einem App-Wechsel):
        // dann sind die Anmeldedaten des Gastes faellig.
        const onWake = (src) => {
          // Das Sichtbarwerden vor dem Cast-Standby-Neustart ist kein Aufwachen
          // (BringToFront.forReboot).
          if (BringToFront.isRebootImminent()) {
            console.log('::===> POWER_STATE ' + src + ' waehrend der Neustart-Vorbereitung - ignoriert');
            return;
          }
          console.log('::===> POWER_STATE ' + src + ' → ON');
          KeyHandlingTizen.savePowerState(STORE_VALUE.POWER_ON);
          // Ob ueberhaupt aufzuraeumen ist, entscheidet clearPending im Store -
          // der Merker ueberlebt auch einen Kaltstart, ein Feld hier nicht.
          KeyHandlingTizen.clearCastCredentials(src + ' nach Standby');
        };
        const onSleep = (src) => {
          console.log('::===> POWER_STATE ' + src + ' → OFF');
          KeyHandlingTizen.savePowerState(STORE_VALUE.POWER_OFF);
          // onHidden/onSuspend feuern AUCH beim Start einer Fremd-App (z.B.
          // YouTube ueber Cast). Nur ein bestaetigter Standby darf vormerken -
          // sonst waere der Gast direkt nach dem Start wieder abgemeldet.
          if (!KeyHandlingTizen.isRealStandby()) return;
          KeyHandlingTizen.prepareCastStandby(src);
        };
        this.powerWrapper = new PowerStateWrapper({
          onResume: () => onWake('onResume'),
          onVisible: () => onWake('onVisible'),
          // WICHTIG: Standby symmetrisch als OFF festhalten. Sonst bleibt im
          // keymanager 'ON' stehen und die WGT-Startdatei schaltet den TV beim
          // nächsten (Neu-)Laden aus dem Standby wieder ein.
          onSuspend: () => onSleep('onSuspend'),
          onHidden: () => onSleep('onHidden'),
        });
        this.powerWrapper.init();
      }
      // Initialen Zustand synchronisieren
      const currentPowerState = window.webapis.remotepower.getPowerState();
      console.log('::===> INITIAL POWER_STATE sync:', currentPowerState);
      StorageHandler.save(
        STORE_KEY.POWER_STATE,
        currentPowerState === 'NORMAL' ? STORE_VALUE.POWER_ON : STORE_VALUE.POWER_OFF
      );
    }
  } catch (error) {
    console.log('[ERROR]: setPowerStateListener!', error);
  }
}

static unsetPowerStateListener() {
  console.log('UNSET POWER STATE LISTENER');
  try {
    if (window.b2bapis) {
      Device.apis.b2bpower.unsetPowerStateChangeListener();
    } else if (window.webapis) {
      if (this.powerWrapper) {
        this.powerWrapper.destroy();
        this.powerWrapper = null;
      }
    }
  } catch (error) {
    console.log('[ERROR]: ON UNSET POWER STATE CHANGE LISTENER', error);
  }
}

  /*
  static setPowerStateListener() {
    console.log("============================================== SET POWER STATE LISTENER");

    if (this.powerWrapper) return;

    this.powerWrapper = new PowerStateWrapper({
      onResume() {
        console.log("::===> POWER_STATE RESUME (POWER ON)");
        StorageHandler.save(
          STORE_KEY.POWER_STATE,
          STORE_VALUE.POWER_ON
        );
      },

      onVisible() {
        console.log("::===> POWER_STATE VISIBLE");
        StorageHandler.save(
          STORE_KEY.POWER_STATE,
          STORE_VALUE.POWER_ON
        );
      },

      onSuspend() {
        console.log("::===> POWER_STATE SUSPEND");
      },

      onHidden() {
        console.log("::===> POWER_STATE HIDDEN");
      },
    });

    this.powerWrapper.init();
  }

  static unsetPowerStateListener() {
    console.log("============================================== UNSET POWER STATE LISTENER");

    if (!this.powerWrapper) return;

    this.powerWrapper.destroy();
    this.powerWrapper = null;
  }
*/

}



// WEBPACK FOOTER //
// ./src/mixins/keyHandler/Tizen.js